/**
 * @see [Hyperverge SDK Response](https://documentation.hyperverge.co/sdks/inputs-outputs/sdk-response)
 * @see [Hypeverge Web SDK Result Handler](https://documentation.hyperverge.co/sdks/web/#step-3---implement-a-results-handler)
 */
const HYPERVERGE_KYC_RESULT_STATUS = {
  USER_CANCELLED: 'user_cancelled',
  ERROR: 'error',
  AUTO_APPROVED: 'auto_approved',
  AUTO_DECLINED: 'auto_declined',
  NEEDS_REVIEW: 'needs_review',
} as const;

/**
 * @description For mobile-app we trigger native sdk for kyc flow.
 * On its completion we need the result, so mobile app sends a message to web-app with this as message name.
 */
const MOBILE_APP_KYC_RESULT_MESSAGE_NAME = 'LAUNCH_HYPERVERGE_SDK_KYC_RESULT';

export { HYPERVERGE_KYC_RESULT_STATUS, MOBILE_APP_KYC_RESULT_MESSAGE_NAME };
